import { createStyles, Theme, emphasize } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		skillsOuterContainer: {
			alignItems: 'center',
		},
		skillsOuterContainerMobile: {
			alignContent: 'flex-start',
			alignItems: 'flex-start',
			// height: '30px',
			overflowY: 'hidden',
		},
		skillsInnerContainer: {
			width: 'auto',
			alignItems: 'center',
		},
		skillsInnerContainerMobile: {
			overflowX: 'auto',
			flexWrap: 'nowrap',
			// height: '50px',
		},
		skillsLabel: {
			color: '#1B1A7C',
			fontSize: '14px',
			marginBottom: '5px',
			marginRight: '10px',
		},
		skillChip: {
			height: '25px',
			color: '#1B1A7C',
			background: 'rgba(27, 26, 124, 0.1)',
			fontSize: '11px',
			fontWeight: 700,
			marginRight: '10px',
			marginBottom: '5px',
		},
		viewAll: {
			fontSize: '14px',
			fontWeight: 400,
			color: '#1B1A7C',
			marginBottom: '5px',
			cursor: 'pointer',
		},
		editIconLabel: {
			paddingLeft: 6,
			paddingRight: 6,
		},
		editRootElement: {
			background: '#fff',
			position: 'absolute',
			top: -1,
			right: 0,
			[theme.breakpoints.down('md')]: {
				top: 0,
				right: 5,
				[theme.breakpoints.only('xs')]: {
					width: 30,
					height: 30,
					'& svg': {
						fontSize: '1.2rem'
					}
				}
			},
		},
		saveEdit: {
			position: 'relative',
			display: 'inline',
			margin: '2px',
			fontSize: 16,
			border: '1px solid #FC2652',
			padding: '0 8px',
			borderRadius: 12,
			color: '#FC2652',
			cursor: 'pointer',
		},
		cancelEdit: {
			position: 'relative',
			display: 'inline',
			margin: '2px',
			fontSize: 16,
			border: '1px solid grey',
			padding: '0 8px',
			borderRadius: 12,
			color: 'grey',
			cursor: 'pointer',
		},
		saveCancelButtons: {
			position: 'absolute',
			top: '0px',
			right: '0px',
		},
		saveSuccess: {
			position: 'absolute',
			right: 0,
			top: 6,
			fontSize: 13,
			color: '#FC2652',
		},
		root: {
			flexGrow: 1,
			height: 250,
		},
		input: {
			display: 'flex',
			padding: 0,
			height: 'auto',
		},
		valueContainer: {
			display: 'flex',
			flexWrap: 'wrap',
			flex: 1,
			alignItems: 'center',
			overflow: 'hidden',
		},
		chip: {
			margin: theme.spacing(0.5, 0.25),
		},
		chipFocused: {
			backgroundColor: emphasize(
				theme.palette.type === 'light'
					? theme.palette.grey[300]
					: theme.palette.grey[700],
				0.08,
			),
		},
		noOptionsMessage: {
			padding: theme.spacing(1, 2),
		},
		placeholder: {
			position: 'absolute',
			left: 2,
			bottom: 6,
			fontSize: 16,
		},
		paper: {
			// position: 'absolute',
			// zIndex: 1,
			// marginTop: theme.spacing(1),
			// left: 0,
			// right: 0
		},
		divider: {
			height: theme.spacing(2),
		},
		skillsSelect: {
			flexGrow: 1,
			marginTop: 8,
			marginBottom: 12,
		},
	})
